import React, { ReactNode } from 'react';
import Tooltip from 'rc-tooltip';
import './bootstrap.scss';

interface Props {
  title: ReactNode;
  id?: string;
}

const ToolTip: React.FC<Props> = ({ title, id }: Props) => {
  return (
    <Tooltip
      id={id}
      placement="top"
      trigger={['hover']}
      overlay={<span>{title}</span>}
      showArrow={true}
    >
      <span className="circle">
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path={`url#${id}`}>
            <path
              d="M9.99999 1.66667C5.39999 1.66667 1.66666 5.4 1.66666 10C1.66666 14.6 5.39999 18.3333 9.99999 18.3333C14.6 18.3333 18.3333 14.6 18.3333 10C18.3333 5.4 14.6 1.66667 9.99999 1.66667ZM10.8333 14.1667H9.16666V9.16667H10.8333V14.1667ZM10.8333 7.5H9.16666V5.83333H10.8333V7.5Z"
              fill="#0F62FE"
            />
          </g>
          <defs>
            <clipPath id={id}>
              <rect width="20" height="20" fill="white" />
            </clipPath>
          </defs>
        </svg>
      </span>
    </Tooltip>
  );
};

export default ToolTip;
